import React from "react"

import { ChildSelector } from "../helpers/ChildSelector"

import * as courseDetailHeader from "../styles/CourseDetailHeader.module.css"

export default function CourseDetailHeader(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `course-level`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const subTitle = ChildSelector.select(
    content,
    `course-name`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const text = content.childNodes.filter(
    node => node.classNames === "course-intro"
  )[0].text

  return (
    <>
      <div className={`row ${courseDetailHeader.wrapper}`}>
        <div className={`col-12 ${courseDetailHeader.holder}`}>
          <h1 className={`${courseDetailHeader.title}`}>{subTitle}</h1>
          {/* <h2 className={`${courseDetailHeader.title}`}>{title}</h2>
          <h3 className={`${courseDetailHeader.subTitle}`}>{subTitle}</h3> */}
          <p className={`${courseDetailHeader.content}`}>{text}</p>
        </div>
      </div>
    </>
  )
}
